import {
  ListItemIcon as MuiListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { isMenuItemWithIcon, ThreePointMenuProps } from '.';

type Props<T> = {
  closeMenu: () => void;
} & ThreePointMenuProps<T>;

const ListItemIcon = styled(MuiListItemIcon)({
  ['> svg']: {
    width: '24px',
    height: '24px',
    paddingRight: '16px'
  }
});

export function ThreePointMenuList<T>({ config, item, closeMenu }: Props<T>): JSX.Element {
  return (
    <MenuList
      sx={(theme) => ({
        paddingY: '24px',
        '.MuiTouchRipple-child': {
          backgroundColor: theme.palette.grey[50]
        }
      })}
    >
      {config.map((listItem) => (
        <MenuItem
          key={listItem.label}
          sx={(theme) => ({
            padding: '0 24px',
            height: '40px',
            margin: '0 0 8px',
            ':last-child': {
              margin: '0'
            },
            ':hover': {
              backgroundColor: theme.palette.grey[50]
            }
          })}
          onClick={() => {
            listItem.onClick(item);
            closeMenu();
          }}
        >
          {isMenuItemWithIcon(listItem) && (
            <ListItemIcon
              sx={(theme) => ({
                color: listItem.isWarning ? theme.palette.error.main : theme.palette.primary.main
              })}
            >
              {listItem.icon}
            </ListItemIcon>
          )}
          <ListItemText>
            <Typography
              sx={(theme) => ({
                fontSize: '1.0rem',
                color: listItem.isWarning ? theme.palette.error.main : theme.palette.primary.main
              })}
            >
              {listItem.label}
            </Typography>
          </ListItemText>
        </MenuItem>
      ))}
    </MenuList>
  );
}
